
    const path = window.location.pathname;
    if (path === '/login') {
      import('./assets/js/core/login-entry.jsx');
    } else {
      import('./assets/js/core/app-preact.jsx');
    }
  